import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_CHECK_PLACE_24H_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import { DSIcon } from '../../../base';

import styles from './CheckPlace24hModal.module.scss';

const CheckPlace24hModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_CHECK_PLACE_24H_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="normal"
      className={styles['check-place-24h-modal']}
    >
      <ModalHeader
        className={styles['check-place-24h-modal__header']}
        onRequestClose={handleModalClose}
        label={
          <>
            <DSIcon name="mystery" size="ml" />
            <br />
            {trans('check.place.24h.modal.title')}
          </>
        }
      />
      <ModalBody className={styles['check-place-24h-modal__body']}>
        <p>{trans('check.place.24h.modal.description')}</p>

        <div>
          <h5 className={styles['check-place-24h-modal__conditions-title']}>
            {trans('check.place.24h.modal.conditions1')}
          </h5>
          <ul className={styles['check-place-24h-modal__conditions-list']}>
            <li>{trans('check.place.24h.modal.conditions1.item1')}</li>
            <li>{trans('check.place.24h.modal.conditions1.item2')}</li>
            <li>{trans('check.place.24h.modal.conditions1.item3')}</li>
          </ul>
        </div>

        <div>
          <h5 className={styles['check-place-24h-modal__conditions-title']}>
            {trans('check.place.24h.modal.conditions2')}
          </h5>
          <p>{trans('check.place.24h.modal.conditions2.item1')}</p>
        </div>
      </ModalBody>
    </Modal>
  ) : null;
};

export default CheckPlace24hModal;
